import React from 'react';
import './ResultsCounter.css';

export interface ResultsCounterProps {
  /** Número de itens exibidos atualmente */
  displayedItems: number;
  /** Total de itens disponíveis */
  totalItems: number;
  /** Indica se está carregando mais itens */
  isLoading?: boolean;
  /** Texto customizado (opcional) */
  label?: string;
  /** Classe CSS adicional */
  className?: string;
}

/**
 * Componente que exibe o contador de resultados exibidos vs total
 *
 * @example
 * ```tsx
 * <ResultsCounter displayedItems={20} totalItems={150} isLoading={false} />
 * // Saída: "Exibindo 20 de 150 resultados"
 * ```
 */
export const ResultsCounter: React.FC<ResultsCounterProps> = ({
  displayedItems,
  totalItems,
  isLoading = false,
  label = 'resultados',
  className = ''
}) => {
  // Se não há itens, não exibe nada
  if (totalItems === 0 && !isLoading) {
    return null;
  }

  return (
    <div className={`results-counter ${className}`}>
      <div className="results-counter-content">
        <i className="fas fa-list"></i>
        <span className="results-counter-text">
          Exibindo <strong>{displayedItems}</strong> de <strong>{totalItems}</strong> {label}
        </span>
        {isLoading && (
          <span className="results-counter-loading">
            <i className="fas fa-spinner fa-spin"></i>
            Carregando mais...
          </span>
        )}
      </div>
    </div>
  );
};

export default ResultsCounter;
